export const types = {
	login: '[Auht] Login',
	logout: '[Auht] Logout',
	getprojects: 'GETPROJECTS',
	websocket: 'WEBSOCKET',
};
